import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors, fontSizes } from '@/styles'

import { ReactComponent as FacebookIcon } from './facebook.svg'
import { ReactComponent as InstagramIcon } from './instagram.svg'
import { ReactComponent as LivLogo } from './liv-rent-logo.svg'
import { ReactComponent as TwitterIcon } from './twitter.svg'

const Wrapper = styled.div`
  height: 60px;
  background: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 60px;

  @media screen and (max-width: 599px) {
    margin: 0 30px;
    border-top: 1px solid #ccc;
    height: 200px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
`

const CopyrightWrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 599px) {
    flex-direction: column;
  }
`

const Copyright = styled.p`
  color: ${colors.regular};
  font-size: ${fontSizes.small};
  letter-spacing: -0.3px;
  line-height: 16px;
  margin: 0 0 0 10px;

  @media screen and (max-width: 599px) {
    display: none;
  }
`

const SocialIconsWrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 599px) {
    flex-direction: column;
    justify-content: center;
    margin-top: 18px;
  }
`

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
`

const CopyrightMobile = styled.p`
  color: ${colors.regular};
  font-size: ${fontSizes.small};
  letter-spacing: -0.3px;
  line-height: 16px;
  margin-top: 18px;

  @media screen and (min-width: 599px) {
    display: none;
  }
`

const currentYear = new Date().getFullYear()
const copyrightText = `Copyright © ${currentYear} LIV Strategies Inc.`

const Footer = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <CopyrightWrapper>
        <Link
          href="/"
          passHref
          aria-label={t('b.landing.home.label', 'liv.rent Homepage')}
          legacyBehavior
        >
          <LivLogo height={28} width={60} />
        </Link>
        <Copyright id="copyright-text">{copyrightText}</Copyright>
      </CopyrightWrapper>
      <SocialIconsWrapper>
        <SocialIcons>
          <a href="https://www.facebook.com/liv.rent/" aria-label="Facebook">
            <FacebookIcon height={48} width={48} />
          </a>
          <a href="https://twitter.com/liv_rent" aria-label="Twitter">
            <TwitterIcon height={48} width={48} />
          </a>
          <a href="https://www.instagram.com/liv.rent/" aria-label="Instagram">
            <InstagramIcon height={48} width={48} />
          </a>
        </SocialIcons>
        <CopyrightMobile>{copyrightText}</CopyrightMobile>
      </SocialIconsWrapper>
      <div className="copyright-icons">
        Icons made by{' '}
        <a
          href="https://www.flaticon.com/authors/smashicons"
          title="Smashicons"
        >
          Smashicons
        </a>{' '}
        from{' '}
        <a href="https://www.flaticon.com/" title="Flaticon">
          www.flaticon.com
        </a>{' '}
        is licensed by{' '}
        <a
          href="http://creativecommons.org/licenses/by/3.0/"
          title="Creative Commons BY 3.0"
          rel="noopener noreferrer"
          target="_blank"
        >
          CC 3.0 BY
        </a>
      </div>
    </Wrapper>
  )
}

export default Footer
